export default "__VITE_ASSET__BSkPss4V__"